import { useEffect, useState } from 'react';
import { supabase } from '@/lib/supabase';
import { PermitRecord } from './usePermitsPer1kData';
import { Place } from '@/types';

interface PeerPermitsData {
  [key: string]: PermitRecord[]; // key is place_fips
}

export function usePeerPermitsData(peers: Place[]) {
  const [data, setData] = useState<PeerPermitsData>({});
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!peers.length) {
      setLoading(false);
      setData({});
      setError(null);
      return;
    }

    setLoading(true);
    setError(null);

    // Create an array of promises for each peer
    const fetchPromises = peers.map(peer => 
      supabase
        .from('acs_bps_metrics_permit_per_1k')
        .select('*')
        .eq('Place', peer.name)
        .eq('place_fips', peer.place_fips)
        .order('year', { ascending: false })
        .limit(1) // We only need the most recent year for ranking
    );

    Promise.all(fetchPromises)
      .then(results => {
        const newData: PeerPermitsData = {};
        let loggedAny = false;
        results.forEach((result, index) => {
          if (result.error) {
            console.error(`Error fetching data for peer ${peers[index].name}:`, result.error);
          } else {
            const peerData = result.data || [];
            newData[peers[index].place_fips] = peerData;

            // Log the permit data for this peer
            const latestData = peerData[0];
            if (latestData) {
              loggedAny = true;
              console.log(`Peer City: ${peers[index].name}`);
              console.log(`  FIPS: ${peers[index].place_fips}`);
              console.log(`  Permits per 1k: ${latestData.permits_per_1k?.toFixed(2)}`);
              console.log(`  Year: ${latestData.year}`);
            }
          }
        });
        if (loggedAny) {
          console.log('------------------------');
        }
        setData(newData);
        setLoading(false);
      })
      .catch(err => {
        console.error('Error fetching peer permits data:', err);
        setError('Failed to fetch peer data');
        setLoading(false);
      });
  }, [peers]);

  return { data, loading, error };
} 